import { IScraperJobConfigurationFragment } from 'apps/spot-quote-control-panel/graphql/ScraperJobConfigurationFragment'
import { useScraperJobConfigurationsQuery } from 'apps/spot-quote-control-panel/graphql/ScraperJobConfigurations'
import { TAutobiddersFiltersSchema } from 'apps/spot-quote-control-panel/schema/AutobiddersFiltersSchema'

interface IUseJobConfigs {
  filters: TAutobiddersFiltersSchema
}

interface IJobConfigs {
  jobConfigs: IScraperJobConfigurationFragment[]
  jobConfigsLoading: boolean
  refetchJobConfigs: () => void
}

export const useJobConfigs = ({ filters }: IUseJobConfigs) => {
  const { data, loading, refetch } = useScraperJobConfigurationsQuery({
    variables: { tmsName: filters.tmsNames, shipperName: filters.shipperNames },
  })
  const { scraperJobConfigurations } = data || {}

  const nodes: IScraperJobConfigurationFragment[] =
    scraperJobConfigurations?.map(job => job as IScraperJobConfigurationFragment) || []

  return {
    jobConfigs: nodes,
    jobConfigsLoading: loading,
    refetchJobConfigs: refetch,
  } as IJobConfigs
}
